import { render, staticRenderFns } from "./SettingPlanAdd.vue?vue&type=template&id=3f3a687d&scoped=true&"
import script from "./SettingPlanAdd.vue?vue&type=script&lang=js&"
export * from "./SettingPlanAdd.vue?vue&type=script&lang=js&"
import style0 from "./SettingPlanAdd.vue?vue&type=style&index=0&id=3f3a687d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3a687d",
  null
  
)

export default component.exports